export enum ConsultationTransferStatus {
    Pending = 1,
    Approved = 2
}